const stats = [
  { value: "500+", label: "Фитнес-клубов", suffix: "" },
  { value: "3 000+", label: "Тренеров", suffix: "" },
  { value: "150 000+", label: "Клиентов в системе", suffix: "" },
  { value: "99.9%", label: "Uptime", suffix: "" },
];

export default function Stats() {
  return (
    <section className="py-16 bg-white border-y border-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-primary">
                {stat.value}
              </div>
              <div className="mt-1 text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
